import Dbm from "dbm";
import React from "react";
import Website from "./index.js";

export const registerAllBlocks = function() {

    Dbm.react.blocks.registerBlock("development/test", "Development test", <Website.development.DevelopmentTest />);
    
    {
        let editor = <Dbm.react.admin.editor.EditorBlockName>
            <Dbm.react.form.LabelledArea label="Test field">
                <Dbm.react.admin.editor.fields.TextField name="est" />
            </Dbm.react.form.LabelledArea>
        </Dbm.react.admin.editor.EditorBlockName>;
        Dbm.react.blocks.registerBlock("development/testWithFields", "Development test with fields", <Website.development.DevelopmentTest />, editor);
    }

    {
        let editor = <Dbm.react.admin.editor.EditorBlockName>
            
        </Dbm.react.admin.editor.EditorBlockName>;
        Dbm.react.blocks.registerBlock("game/game", "Game", <Website.game.GameContentBlock />, editor);
    }
}

export const setupSettings = function() {

    Dbm.graphapi.webclient.setup(build.wsPath, build.apiPath);

    let siteItem = Dbm.repository.getItem("site");

    let currentUrl = new URL(document.location.href);
    siteItem.setValue("developmentMode", currentUrl.searchParams.get("developmentMode") === "1");

    let gameMode = currentUrl.searchParams.get("gameMode");
    if(!gameMode) {
        gameMode = "normal";
    }
    siteItem.setValue("gameMode", gameMode);
}

export const setupSiteMode = function() {
    setupSettings();
    let siteItem = Dbm.repository.getItem("site");
    siteItem.setValue("loggedInUrl", "/my-account/");
    siteItem.setValue("currentUser", null);
    siteItem.setValue("loginActions", {});

    Dbm.site.setupAndStart("SvN Tillväxtspelet");
}

export const setup = function() {

    setupSiteMode();

    Dbm.react.modules.addModuleCreator("index", <Website.layout.Main />);
    
}

export const setupSignin = function() {

    setupSiteMode();

    Dbm.react.modules.addModuleCreator("index", <div className="centered-site">
        <Dbm.react.blocks.signin.SignIn />
    </div>);
    
}

export const setupGame = function() {

    setupSettings();

    Dbm.react.modules.addModuleCreator("index", <div>
        <Website.game.GameHolder />
    </div>);
    
} 